import script from "./IdeaActivityNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdeaActivityNotification.vue?vue&type=script&setup=true&lang=ts"

import "./IdeaActivityNotification.vue?vue&type=style&index=0&id=06bdacaf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bdacaf"]])

export default __exports__